import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FilterService } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { registerInListTableFilter } from './core/config/in-list-table-filter';
import { InListFilterTemplateService } from './core/services/in-list-filter-template.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	standalone: false,
})
export class AppComponent implements OnInit, AfterViewInit {
	@ViewChild('inListTextFilterTemplate') inListTextFilterTemplate: TemplateRef<unknown>;
	layoutMode = 'static'; //'overlay';

	darkMenu = true;

	isRTL = false;

	compactMode = false;

	inputStyle = 'outlined';

	ripple = true;

	constructor(
		private primengConfig: PrimeNG,
		private filterService: FilterService,
		private inListFilterTemplateService: InListFilterTemplateService
	) {}

	ngOnInit() {
		this.primengConfig.ripple.set(true);
		registerInListTableFilter(this.filterService);
	}

	ngAfterViewInit(): void {
		this.inListFilterTemplateService.setTemplate(this.inListTextFilterTemplate);
	}
}
